module.exports = __webpack_public_path__ + "static/img/3_1_6.5a16e2b4.jpg";